(function(){
  'use strict';
  var C = window.SoulStoneMobileApp || {};
  if (!C.root) return;

  var q = function(s,r){ return (r || document).querySelector(s); };
  var qa = function(s,r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function(v){ return String(v || '').replace(/[&<>"']/g,function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]; }); };

  var icon = function(name){
    var icons = {
      ment:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>',
      search:'<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.7" cy="10.7" r="6.4"/><path d="m15.6 15.6 4.4 4.4"/></svg>',
      cart:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 4h2.2l1.8 10.1a2 2 0 0 0 2 1.7h7.7a2 2 0 0 0 2-1.6L20.4 8H7"/><circle cx="10" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>',
      home:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 11.2 12 4l8.5 7.2"/><path d="M5.5 10v10h13V10M9.5 20v-6h5v6"/><path d="M19 4.5v2.8M17.6 5.9h2.8"/></svg>',
      bag:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/><path d="M18.5 3.5v3M17 5h3"/></svg>',
      guidance:'<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="3" width="12" height="18" rx="1.8"/><path d="M15.7 8.1a4.2 4.2 0 0 1-5.8-3.5 4.4 4.4 0 1 0 5.8 3.5Z"/><path d="M9 16h6"/></svg>',
      user:'<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.4"/><path d="M5 20c.7-4 3-6 7-6s6.3 2 7 6"/><path d="M19 3v3M17.5 4.5h3"/></svg>'
    };
    return icons[name] || icons.home;
  };

  var logo = C.logo ? '<img src="' + esc(C.logo) + '" alt="SoulStone Co.">' : '<span class="ssm-brand-fallback">SOULSTONE CO.</span>';
  var cartBadge = parseInt(C.cartCount,10) > 0 ? '<span class="ssm-cart-count">' + esc(C.cartCount) + '</span>' : '';

  var homeVisual = '';
  if (C.isIndex) {
    homeVisual =
      '<section class="ssm-approved-visual" aria-label="SoulStone quick shop">' +
        '<button type="button" class="ssm-hotspot ssm-hotspot-menu" data-ssm-menu-open aria-label="Open menu">Menu</button>' +
        '<a class="ssm-hotspot ssm-hotspot-logo" href="' + esc(C.root) + '" aria-label="SoulStone Co. home">Home</a>' +
        '<a class="ssm-hotspot ssm-hotspot-header-search" href="' + esc(C.search) + '" aria-label="Search SoulStone Co.">Search</a>' +
        '<a class="ssm-hotspot ssm-hotspot-cart" href="' + esc(C.cart) + '" aria-label="Cart">Cart</a>' +
        '<a class="ssm-hotspot ssm-hotspot-main-search" href="' + esc(C.search) + '" aria-label="Search crystals, apparel and designs">Search</a>' +
        '<a class="ssm-hotspot ssm-hotspot-crystals" href="' + esc(C.crystals) + '" aria-label="Shop crystals">Crystals</a>' +
        '<a class="ssm-hotspot ssm-hotspot-apparel" href="' + esc(C.apparel) + '" aria-label="Shop apparel and merch">Apparel &amp; Merch</a>' +
        '<a class="ssm-hotspot ssm-hotspot-designs" href="' + esc(C.designs) + '" aria-label="Shop designs">Designs</a>' +
        '<a class="ssm-hotspot ssm-hotspot-guidance" href="' + esc(C.guidance) + '" data-ssm-guidance aria-label="Daily Guidance">Daily Guidance</a>' +
        '<button type="button" class="ssm-hotspot ssm-hotspot-install" data-ssm-install-open aria-label="Add SoulStone to your phone">Add SoulStone to your phone</button>' +
      '</section>';
  }

  var standardTopbar = '';
  if (!C.isIndex) {
    standardTopbar =
      '<header class="ssm-topbar" aria-label="SoulStone mobile header">' +
        '<button class="ssm-icon-btn" type="button" aria-label="Open menu" data-ssm-menu-open>' + icon('menu') + '</button>' +
        '<a class="ssm-brand" href="' + esc(C.root) + '" aria-label="SoulStone Co. home">' + logo + '</a>' +
        '<div class="ssm-top-actions">' +
          '<a class="ssm-icon-btn" href="' + esc(C.search) + '" aria-label="Search">' + icon('search') + '</a>' +
          '<a class="ssm-icon-btn" href="' + esc(C.cart) + '" aria-label="Cart">' + icon('cart') + cartBadge + '</a>' +
        '</div>' +
      '</header>';
  }

  var shell = document.createElement('div');
  shell.className = 'ss-mobile-app';
  shell.setAttribute('data-soulstone-mobile-app','');
  shell.innerHTML =
    standardTopbar + homeVisual +
    '<nav class="ssm-nav" aria-label="SoulStone app navigation">' +
      '<a href="' + esc(C.root) + '" data-ssm-tab="home">' + icon('home') + '<span>Home</span></a>' +
      '<a href="' + esc(C.shop) + '" data-ssm-tab="shop">' + icon('bag') + '<span>Shop</span></a>' +
      '<a href="' + esc(C.guidance) + '" data-ssm-tab="guidance" data-ssm-guidance>' + icon('guidance') + '<span>Guidance</span></a>' +
      '<a href="' + esc(C.search) + '" data-ssm-tab="search">' + icon('search') + '<span>Search</span></a>' +
      '<a href="' + esc(C.account) + '" data-ssm-tab="account">' + icon('user') + '<span>Account</span></a>' +
    '</nav>' +
    '<div class="ssm-menu-backdrop" data-ssm-menu-backdrop></div>' +
    '<aside class="ssm-sheet" data-ssm-menu-sheet aria-hidden="true">' +
      '<div class="ssm-sheet-head"><h2 class="ssm-sheet-title">Explore SoulStone</h2><button class="ssm-sheet-close" type="button" aria-label="Close menu" data-ssm-menu-close>×</button></div>' +
      '<div class="ssm-menu-logo">' + logo + '</div>' +
      '<div class="ssm-menu-list">' +
        '<a href="' + esc(C.decks) + '"><span>Deck Nation</span><span>›</span></a>' +
        '<a href="' + esc(C.readings) + '"><span>Psychic Readings</span><span>›</span></a>' +
        '<a href="' + esc(C.apparel) + '"><span>Apparel &amp; Merch</span><span>›</span></a>' +
        '<a href="' + esc(C.crystals) + '"><span>Crystals</span><span>›</span></a>' +
        '<a href="' + esc(C.designs) + '"><span>Designs &amp; transfers</span><span>›</span></a>' +
        '<a href="' + esc(C.shop) + '"><span>Shop all</span><span>›</span></a>' +
        '<a href="' + esc(C.soulNotes) + '"><span>Soul Notes</span><span>›</span></a>' +
        '<a href="' + esc(C.contact) + '"><span>Contact</span><span>›</span></a>' +
      '</div>' +
    '</aside>' +
    '<div class="ssm-install-backdrop" data-ssm-install-backdrop></div>' +
    '<aside class="ssm-sheet" data-ssm-install-sheet aria-hidden="true">' +
      '<div class="ssm-sheet-head"><h2 class="ssm-sheet-title">Put SoulStone on your phone</h2><button class="ssm-sheet-close" type="button" aria-label="Close install instructions" data-ssm-install-close>×</button></div>' +
      '<p class="ssm-install-copy" data-ssm-install-copy></p>' +
      '<button type="button" class="ssm-native-install" data-ssm-native-install hidden>Install SoulStone</button>' +
      '<p class="ssm-sheet-note">This uses the SoulStone website you already have — there is no extra monthly app fee.</p>' +
    '</aside>';

  document.body.insertBefore(shell, document.body.firstChild);
  if (C.isIndex) document.body.classList.add('ssm-index');

  var standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
  if (standalone) document.documentElement.classList.add('ssm-standalone');

  var deferredPrompt = null;
  window.addEventListener('beforeinstallprompt', function(e){
    e.preventDefault();
    deferredPrompt = e;
    var b = q('[data-ssm-native-install]');
    if (b) b.hidden = false;
  });

  var setSheet = function(kind, open){
    var menu = kind === 'menu';
    var sheet = q(menu ? '[data-ssm-menu-sheet]' : '[data-ssm-install-sheet]');
    var back = q(menu ? '[data-ssm-menu-backdrop]' : '[data-ssm-install-backdrop]');
    if (!sheet || !back) return;
    sheet.classList.toggle('is-open', open);
    back.classList.toggle('is-open', open);
    sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('ssm-lock', open);
  };

  qa('[data-ssm-menu-open]').forEach(function(b){ b.addEventListener('click', function(){ setSheet('menu', true); }); });
  var menuClose = q('[data-ssm-menu-close]');
  var menuBack = q('[data-ssm-menu-backdrop]');
  if (menuClose) menuClose.addEventListener('click', function(){ setSheet('menu', false); });
  if (menuBack) menuBack.addEventListener('click', function(){ setSheet('menu', false); });

  var installCopy = q('[data-ssm-install-copy]');
  var isiOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  if (installCopy) {
    installCopy.innerHTML = isiOS
      ? '<strong>iPhone/iPad:</strong> open SoulStone in Safari, tap Share, choose <strong>Add to Home Screen</strong>, then tap Add.'
      : '<strong>Android:</strong> open the browser menu (⋮) and choose <strong>Add to Home screen</strong> or <strong>Install app</strong> if offered.';
  }
  qa('[data-ssm-install-open]').forEach(function(b){ b.addEventListener('click', function(){ setSheet('install', true); }); });
  var installClose = q('[data-ssm-install-close]');
  var installBack = q('[data-ssm-install-backdrop]');
  if (installClose) installClose.addEventListener('click', function(){ setSheet('install', false); });
  if (installBack) installBack.addEventListener('click', function(){ setSheet('install', false); });

  var nativeInstall = q('[data-ssm-native-install]');
  if (nativeInstall) nativeInstall.addEventListener('click', function(){
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.finally(function(){
      deferredPrompt = null;
      nativeInstall.hidden = true;
      setSheet('install', false);
    });
  });

  var scrollGuidance = function(){
    var el = q('.ssc-dg');
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 74;
    window.scrollTo({top:y, behavior:'smooth'});
    return true;
  };
  qa('[data-ssm-guidance]').forEach(function(a){
    a.addEventListener('click', function(e){
      if (scrollGuidance()) {
        e.preventDefault();
        history.replaceState(null, '', C.guidance);
      }
    });
  });
  if (/(?:\?|&)ssapp=guidance(?:&|$)/.test(location.search)) {
    var attempts = 0;
    var t = setInterval(function(){
      attempts++;
      if (scrollGuidance() || attempts > 24) clearInterval(t);
    },125);
  }

  var p = location.pathname.toLowerCase();
  var active = 'home';
  if (p.indexOf('/search') > -1) active = 'search';
  else if (p.indexOf('/account') > -1) active = 'account';
  else if (/(?:\?|&)ssapp=guidance(?:&|$)/.test(location.search)) active = 'guidance';
  else if (p.indexOf('/products/') > -1 || p.indexOf('/collections/') > -1 || p.indexOf('/pages/shop-all') > -1 || p.indexOf('/pages/uv-dtf-dtf') > -1) active = 'shop';
  qa('[data-ssm-tab]').forEach(function(a){
    if (a.getAttribute('data-ssm-tab') === active) {
      a.classList.add('is-active');
      a.setAttribute('aria-current','page');
    }
  });
})();
